import script from "./LimitesCreditoCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./LimitesCreditoCadastro.vue?vue&type=script&setup=true&lang=js"

import "./LimitesCreditoCadastro.vue?vue&type=style&index=0&id=3251ceb0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3251ceb0"]])

export default __exports__